import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DataStory from '../story/DataStory.jsx';

const DataStoryPage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6">Daily Digest</Typography>
        <Typography variant="body2" color="text.secondary">
          Seven-day digest of triggers, status changes, action required updates, VMT pushes, and DB warning/error logs.
        </Typography>
      </Paper>
      <DataStory />
    </Box>
  );
};

export default DataStoryPage;

